import * as React from 'react';
import styled from 'styled-components';
import { Spacer, Text } from '../../parts';
import { AppStoreModal } from '../../components/AppStoreModal';

interface SignUpPromoProps {}

export const SignUpPromo: React.FC<SignUpPromoProps> = (props) => {
	const [isModalOpen, setIsModalOpen] = React.useState(false);

	const isAndroid = navigator?.userAgent?.toLowerCase().indexOf('android') > -1;
	const isIPhone = navigator?.userAgent?.toLowerCase().indexOf('iphone') > -1;
	const isWeb = !isAndroid && !isIPhone;

	const openAppInStore = () => {
		if (isAndroid) {
			window.location.href = 'https://play.google.com/store/apps/details?id=com.access.liverewards&hl=en&gl=US';
		}
		if (isIPhone) {
			window.location.href = 'https://apps.apple.com/us/app/live-rewards/id1470069033';
		}
	};

	const openIOSApp = () => {
		window.location.href = 'https://apps.apple.com/us/app/live-rewards/id1470069033';
	};

	const openAndroidApp = () => {
		window.location.href = 'https://play.google.com/store/apps/details?id=com.access.liverewards&hl=en&gl=US';
	};

	const handleGetStarted = () => {
		if (isWeb) {
			setIsModalOpen(true);
		} else {
			openAppInStore();
		}
	};

	return (
		<>
			<AppStoreModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onIOSClick={openIOSApp} onAndroidClick={openAndroidApp} />
			<SignUpPromoBody>
				<Cont>
					<Text weight="heavy" size={40} color="white" style={{ textAlign: 'center' }}>
						See how much you can save.
					</Text>
					<Spacer size={15} />
					<GetBtn onClick={handleGetStarted}>Get Started</GetBtn>
					{/* <Spacer size={4} />
					<Text size={14} style={{ fontStyle: 'italic' }} color="white">
						$3.99/Month after the 14 day trial
					</Text> */}
				</Cont>
			</SignUpPromoBody>
		</>
	);
};

const SignUpPromoBody = styled.div`
	height: 200px;
	width: 100%;
	background-image: linear-gradient(280deg, #91c1f4 0%, #027dfd 70%);
`;

const Cont = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	align-items: center;

	@media only screen and (min-width: 1200px) {
		margin: 0 auto;
		max-width: 1200px;
	}
`;

const GetBtn = styled.p`
	padding: 6px 34px;
	background: white;
	font-weight: 700;
	border-radius: 50px;
	user-select: none;
	cursor: pointer;

	transition: opacity 0.1s ease-in-out;
	&:hover {
		opacity: 0.5;
	}
	&:active {
		opacity: 0.4;
	}
`;
